import { render, staticRenderFns } from "./KnMenu.vue?vue&type=template&id=2fde6cf8"
import script from "./KnMenu.vue?vue&type=script&lang=js"
export * from "./KnMenu.vue?vue&type=script&lang=js"
import style0 from "./KnMenu.vue?vue&type=style&index=0&id=2fde6cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports